// extracted by mini-css-extract-plugin
export default {"root":"EPWkVGUN","warning":"YmOsOtSh"};